<template>
  <div class="ideas-grid ideas-grid-scrollable" v-if="gridview">
    <idea-grid-item v-for="idea in ideas" :idea="idea" :key="idea.id" />
    <infinite-horizontal
      direction="right"
      ref="infiniteLoading"
      @infinite="infiniteHandler"
    >
      <div slot="no-more"></div>
      <div slot="no-results">Keine Treffer</div></infinite-horizontal
    >
  </div>
</template>

<script>
export default {
  props: ["classes", "type"],
  data() {
    return {
      ideas: [],
      gridview: true,
      page: 1,
      mute: false,
      ideasTotal: 0,
    };
  },
  watch: {},
  methods: {
    async infiniteHandler($state) {
      this.mute = true;
      let filter = "";
      if (this.type == "new") {
        filter = "new";
      } else {
        filter = "popular";
      }
      // console.log("INFINITE HANDLER CALLED", tmp, this.page);
      const { data } = await axios.get("/api/ideas", {
        params: { container: filter, page: this.page },
      });
      console.log("RES", data);
      if (data.data.length < 1) {
      }
      if (this.page <= data.last_page) {
        this.ideasTotal = data.total;
        this.page = this.page + 1;

        this.ideas.push(...data.data);
        console.log(this.ideas);
        $state.loaded();
      } else {
        $state.complete();
      }
    },

    toggleView() {
      this.gridview = !this.gridview;
    },
    // async read() {
    //   this.mute = true;
    //   let filter = "";
    //   if (this.type == "new") {
    //     filter = "new";
    //   } else {
    //     filter = "popular";
    //   }
    //   window.axios
    //     .get("/api/ideas", {
    //       params: {
    //         container: filter,
    //       },
    //     })
    //     .then((res) => {
    //       this.ideas = res.data;
    //     });
    // },
  },
  mounted() {
    // this.read();
  },
};
</script>

<style>
</style>
